module.exports = require("Vuex");